import axios from "axios";
import { ENDPOINT } from "constants/environment";
import { decryptData } from "helpers";
import { encryptData } from "helpers";
import { getHeaderConfig } from "helpers";
import { consoleLog } from "helpers";

export const sendEmailAPI = async (payload, isLoading, accessJWT) => {
  try {
    isLoading(true);
    const config = getHeaderConfig(null, accessJWT);
    const response = await axios.post(
      `${ENDPOINT}/app/v1/sendEmail`,
      encryptData(payload),
      config
    );
    const parsedResponseData = JSON.parse(decryptData(response?.data));
    if (parsedResponseData && parsedResponseData.statusCode === 200) {
      if (isLoading) isLoading(false);
      return parsedResponseData?.data;
    }
    if (isLoading) isLoading(false);
    throw Error;
  } catch (error) {
    if (isLoading) isLoading(false);
    console.error("Error sending Email", error);
    return null;
  }
};

export const previewEmailAPI = async (payload, isLoading, accessJWT) => {
  try {
    if (isLoading) isLoading(true);

    const config = getHeaderConfig(null, accessJWT);

    consoleLog(["Sending request to preview email:", payload]);

    const response = await axios.post(
      `${ENDPOINT}/app/v1/preview`,
      encryptData(payload),
      config
    );

    consoleLog(["Raw API Response:", response]);

    const decryptedData = decryptData(response?.data);
    consoleLog(["Decrypted Data:", decryptedData]);

    let parsedResponseData;
    try {
      parsedResponseData = JSON.parse(decryptedData);
      consoleLog(["Parsed Response Data:", parsedResponseData]);
    } catch (parseError) {
      console.error("Error parsing the decrypted response:", parseError);
    }

    if (parsedResponseData && parsedResponseData?.statusCode === 200) {
      if (isLoading) isLoading(false);
      return parsedResponseData?.data;
    }

    if (isLoading) isLoading(false);
    throw Error("Invalid response from API");
  } catch (error) {
    if (isLoading) isLoading(false);
    console.error("Error previewing Email:", error);
    return null;
  }
};

export const adminLoginAPI = async (payload, accessJWT) => {
  try {
    const config = getHeaderConfig(null, accessJWT);

    const response = await axios.post(
      `${ENDPOINT}/app/v1/auth/adminLogin`,

      encryptData(payload),
      config
    );

    const parsedResponse = JSON.parse(decryptData(response?.data));
    consoleLog([parsedResponse, "parsedResponse"]);
    return parsedResponse;
  } catch (err) {
    console.error("Admin login API error", err);

    return {
      statusCode: 500,
      message: "Something went wrong with admin login",
    };
  }
};
export const generateOtpAPI = async (payload, accessJWT) => {
  try {
    const config = getHeaderConfig(null, accessJWT);
    const response = await axios.post(
      `${ENDPOINT}/app/v1/auth/generateOTP`,
      encryptData(payload),
      config
    );
    consoleLog([response, "responseresponse"]);
    const parsedData = JSON.parse(decryptData(response?.data));
    return parsedData;
  } catch (error) {
    console.error("Error in generateOtpAPI", error);
    throw error;
  }
};

export const verifyOtpAPI = async (payload, accessJWT) => {
  try {
    const config = getHeaderConfig(null, accessJWT);
    const response = await axios.post(
      `${ENDPOINT}/app/v1/auth/verify`,
      encryptData(payload),
      config
    );
    const parsedData = JSON.parse(decryptData(response?.data));
    return parsedData;
  } catch (error) {
    console.error("Error in verifyOtpAPI", error);
    throw error;
  }
};
export const suggestEmailAPI = async (query, accessJWT) => {
  try {
    const config = getHeaderConfig(null, accessJWT);
    consoleLog(["Request Headers:", config.headers]);
    const body = {
      email: query,
    };

    const response = await axios.post(
      `${ENDPOINT}/app/v1/suggestEmail`,
      encryptData(body),
      config
    );
    consoleLog(["Response:", response]);
    const parsedResponseData = JSON.parse(decryptData(response?.data));
    if (parsedResponseData && parsedResponseData.statusCode === 200) {
      return parsedResponseData?.data || [];
    }
    throw new Error("Failed to fetch email suggestions");
  } catch (error) {
    console.error("Error suggesting email", error);
    return [];
  }
};

export const getEmailTypesAPI = async (accessJWT) => {
  try {
    const config = getHeaderConfig(null, accessJWT);

    const response = await axios.get(`${ENDPOINT}/app/v1/emailType`, config);

    consoleLog(["API Response:", response]);

    const parsedResponseData = JSON.parse(decryptData(response?.data));
    consoleLog(["Parsed Response Data:", parsedResponseData]);

    if (parsedResponseData && parsedResponseData.statusCode === 200) {
      return parsedResponseData?.data || [];
    }

    throw new Error("Failed to fetch email types");
  } catch (error) {
    console.error("Error fetching email types", error);
    return [];
  }
};

export const fetchUpcomingTripsAPI = async (userId, accessJWT) => {
  try {
    consoleLog([userId, "userId"]);
    const config = getHeaderConfig(null, accessJWT);
    const body = {
      userId: userId,
    };

    const response = await axios.post(
      `${ENDPOINT}/app/v1/upcommingTrips`,
      encryptData(body),
      config
    );
    consoleLog([response, "response"]);

    const parsedResponseData = JSON.parse(decryptData(response?.data));
    if (parsedResponseData && parsedResponseData.statusCode === 200) {
      return parsedResponseData?.data || [];
    }

    throw new Error("Failed to fetch upcoming trips");
  } catch (error) {
    console.error("Error fetching upcoming trips:", error);
    return [];
  }
};
